import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { FontFamily } from '../../../constants/fonts';
import { useTheme } from '../../../theme';
import { TEXT_MUTED, TEXT_STRONG } from '../constants/colors';

interface TicketingAnalyticsSummaryRowProps {
  /**
   * Pre-composed summary text (e.g. "All tickets · Period to date (P6 2026)").
   * Built by `getTicketingSummary` — this component performs no formatting.
   */
  text: string;
}

/**
 * Presentational row describing the data currently shown on the dashboard.
 * Intentionally free of business logic: it renders the provided text as-is.
 */
const TicketingAnalyticsSummaryRow: React.FC<TicketingAnalyticsSummaryRowProps> = ({ text }) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';
  return (
    <View accessibilityRole="summary">
      <Text style={styles.summaryText}>
        <Text style={[styles.label, isDark && { color: colors.text.secondary }]}>Showing data for: </Text>
        <Text style={[styles.value, isDark && { color: colors.text.primary }]}>{text}</Text>
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  summaryText: {
    fontSize: 13,
    lineHeight: 18,
  },
  label: {
    fontFamily: FontFamily.regular,
    color: TEXT_MUTED,
  },
  value: {
    fontFamily: FontFamily.medium,
    color: TEXT_STRONG,
  },
});

export default TicketingAnalyticsSummaryRow;
